import useSWR from 'swr';
import { patch } from './utils';
import urlResolver from 'admin/utils/URLResolver';

export const useClassActivityResponses = (
  activityId,
  classId,
  refreshInterval = 0
) => {
  const activityResponsesUrl = urlResolver.reverse(
    'api:activities:class-activity-responses',
    { activityId, classId }
  );

  const { data, mutate, error } = useSWR(activityResponsesUrl, {
    refreshInterval,
  });

  const updateCollaborators = async (collaborators, activityId) => {
    const url = urlResolver.reverse(
      'api:activities:activity-response-update-collaborators',
      {
        activityResponseId: activityId,
      }
    );

    await patch(url, { collaborators });
    mutate();
  };

  if (error) {
    console.error(error);
  }

  return {
    data,
    loading: !data && !error,
    error,
    updateCollaborators,
  };
};
